import type { EventIncidentType } from "app/types/eventType";
import { RunnerTypes } from "app/utils/const";
//
export class CheckDangerZoneSideHelper {
  static checkDangerZoneSide: any = (eventIncidents: EventIncidentType[]) => {
    let isHome;
    let isAway;
    const dangerZoneState =
      eventIncidents != null ? eventIncidents[0]["dangerballStatus"] : "";
    const incidentType =
      eventIncidents != null && eventIncidents[0].type !== undefined
        ? eventIncidents[0].type
        : null;

    // BET-5610 incident type available give precedence
    if (incidentType === null) {
      isHome = dangerZoneState && dangerZoneState.includes(RunnerTypes.HOME);
      isAway = dangerZoneState && dangerZoneState.includes(RunnerTypes.AWAY);
    } else {
      isHome = incidentType.includes(RunnerTypes.HOME);
      isAway = incidentType.includes(RunnerTypes.AWAY);
    }

    // BET-5712 possible var event incident has no particapant id so no side is returned from API
    if (incidentType === null && dangerZoneState.includes("POSSIBLE")) {
      isHome = true;
      isAway = false;
    }

    //
    if (isHome) return "isHome";
    else if (isAway) return "isAway";
    else return "";
  };
}
